export default __webpack_public_path__ + "static/media/edital19.cc065231.pdf";